import React from 'react';
import styled from 'styled-components/macro';
import Headline1 from '../../../components/typography/Headline1';
import LabelLight from '../../../components/typography/LabelLight';

interface PageTitleProps {
  headline?: string;
  subline?: string;
  children?: React.ReactNode; // should be PageAttribute components
}

const Container = styled.div`
  display: flex;
  padding: 8px 16px;

  > div {
    border-left: 1px solid ${(props) => props.theme.colors.neutral02};
    padding-left: 16px;
    margin-right: 16px;
    min-width: unset;
  }

  > div:first-child {
    border-left: none;
    padding-left: 0;
  }
`;

const PageTitle = (props: PageTitleProps) => {
  return (
    <Container>
      {!!props.headline && (
        <div>
          <Headline1>{props.headline}</Headline1>
          {!!props.subline && <LabelLight>{props.subline}</LabelLight>}
        </div>
      )}
      {props.children}
    </Container>
  );
};

export default PageTitle;
